import React from "react";
import { DeleteModal } from "../../../Common/DeleteModal";
import { BannerTable } from "../../../Common/BannerTable";

export function AdvertisingImage() {
    return (
        <div className="banner-container">
            <section className="text-section">
                <BannerTable
                    section={"AdvertisingImage"}
                    path={["template", "Application", "ImagePublicite", "Pubs"]}
                />
                <DeleteModal section="AdvertisingImage" />
            </section>
        </div>
    );
}
